import { fetchUser, fetchUsers, saveUser } from '../../../services/UserService';

import { DEFAULT_PAGE_SIZE } from '../../../constants';

export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const USER_EDITING = 'USER_EDITING';

// ACTION GENERATORS
const fetchUsersAction = (customerId, pageNumber = 1, pageSize = DEFAULT_PAGE_SIZE) => ({
    type: FETCH_USERS,
    payload: fetchUsers(customerId, pageNumber, pageSize),
});

const fetchUserAction = userId => ({
    type: FETCH_USER,
    payload: fetchUser(userId),
});

const newUserAction = () => ({
    type: `${FETCH_USER}_FULFILLED`,
    payload: null,
});

const saveUserAction = user => ({
    type: FETCH_USER,
    payload: saveUser(user),
});

const editModeAction = isEditing => ({
    type: USER_EDITING,
    payload: isEditing,
});

// EXPORT ACTIONS
export {
    fetchUserAction as fetchUser,
    fetchUsersAction as fetchUsers,
    newUserAction as newUser,
    saveUserAction as saveUser,
    editModeAction as setUserEditMode,
};
